import NovaOrb from "@/components/NovaOrb";
import type { NovaState } from "@/components/NovaOrb";

interface NovaLogoProps {
  size?: "sm" | "md" | "lg" | "hero";
  state?: NovaState;
  stage?: number;
  subtitle?: string;
  className?: string;
}

const sizeConfig = {
  sm: { fontSize: "text-lg", orbContainer: 22, orbScale: 0.55, subtitleSize: "text-[10px]", gap: "gap-0", mx: "-mx-0.5" },
  md: { fontSize: "text-xl", orbContainer: 26, orbScale: 0.65, subtitleSize: "text-xs", gap: "gap-0", mx: "-mx-0.5" },
  lg: { fontSize: "text-3xl", orbContainer: 36, orbScale: 0.9, subtitleSize: "text-sm", gap: "gap-0.5", mx: "-mx-0.5" },
  hero: { fontSize: "text-5xl md:text-7xl", orbContainer: 64, orbScale: 1.6, subtitleSize: "text-lg", gap: "gap-1", mx: "mx-0" },
};

export default function NovaLogo({ size = "md", state = "idle", stage = 1, subtitle, className = "" }: NovaLogoProps) {
  const config = sizeConfig[size];

  return (
    <div className={`flex flex-col items-center ${config.gap} ${className}`} data-testid="nova-logo">
      <div className="flex items-center">
        <span className={`font-display font-bold ${config.fontSize} tracking-tight text-primary select-none leading-none`}>
          ZEN
        </span>
        <div
          className={`relative flex items-center justify-center ${config.mx}`}
          style={{ width: config.orbContainer, height: config.orbContainer }}
        >
          <div style={{ transform: `scale(${config.orbScale})`, transformOrigin: "center" }}>
            <NovaOrb state={state} stage={stage} size="sm" />
          </div>
        </div>
        <span className={`font-display font-bold ${config.fontSize} tracking-tight text-primary select-none leading-none`}>
          VA
        </span>
      </div>
      {subtitle && (
        <span className={`${config.subtitleSize} text-muted-foreground font-medium`}>
          {subtitle}
        </span>
      )}
    </div>
  );
}
